import { SET_SESSION_PERMISSION } from '@constants/actionType'

const initialState = {
  permisos: [],
  secciones: {
    navega: null,
    lista: []
  }
}

function sessionPermission(state = initialState, actions) {
  switch (actions.type) {
    case SET_SESSION_PERMISSION:
      return { ...actions.payload }
    default:
      return state
  }
}

export default sessionPermission